import React, { useEffect } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Label from "./LabelF";
import PropTypes from "prop-types";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import ListSubheader from "@mui/material/ListSubheader";
import Popper from "@mui/material/Popper";
import { useTheme, styled } from "@mui/material/styles";
import { VariableSizeList } from "react-window";
import Typography from "@mui/material/Typography";

const LISTBOX_PADDING = 8; // px

function renderRow(props) {
  const { data, index, style } = props;
  const dataSet = data[index];
  const inlineStyle = {
    ...style,
    top: style.top + LISTBOX_PADDING,
  };

  if (dataSet.hasOwnProperty("group")) {
    return (
      <ListSubheader key={dataSet.key} component="div" style={inlineStyle}>
        {dataSet.group}
      </ListSubheader>
    );
  }

  return (
    <Typography component="li" {...dataSet[0]} noWrap style={inlineStyle}>
      {dataSet[1]}
    </Typography>
  );
}

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

function useResetCache(data) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);
  return ref;
}

// Adapter for react-window
const ListboxComponent = React.forwardRef(function ListboxComponent(
  props,
  ref
) {
  const { children, ...other } = props;
  const itemData = [];
  children.forEach((item) => {
    itemData.push(item);
    itemData.push(...(item.children || []));
  });

  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"), {
    noSsr: true,
  });

  const itemCount = itemData.length;
  const itemSize = smUp ? 36 : 48;

  const getChildSize = (child) => {
    if (child.hasOwnProperty("group")) {
      return 48;
    }

    return itemSize;
  };

  const getHeight = () => {
    if (itemCount > 8) {
      return 8 * itemSize;
    }
    return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
  };

  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <VariableSizeList
          itemData={itemData}
          height={getHeight() + 2 * LISTBOX_PADDING}
          width="100%"
          ref={gridRef}
          outerElementType={OuterElementType}
          innerElementType="ul"
          itemSize={(index) => getChildSize(itemData[index])}
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

ListboxComponent.propTypes = {
  children: PropTypes.node,
};

const StyledPopper = styled(Popper)({
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: "border-box",
    "& ul": {
      padding: 0,
      margin: 0,
    },
  },
});

export default function Virtualize({
  cab,
  data,
  context,
  indiceData,
  campokey,
  valor,
  setValor,
}) {
  // useEffect(() => {
  //   console.log("cab.opciones:", cab.opciones);
  // }, [cab.opciones]);

  const handleChangeValue = async (newValue) => {
    const valor = newValue.value; //newValue { value, label }
    setValor(valor);
  };

  const sortedOptions = cab.opciones
    ? cab.opciones.filter(option => option.label).sort((a, b) => {
        // console.log("Comparing:", a, b);
        return a.label.toUpperCase().localeCompare(b.label.toUpperCase());
      })
    : [];

  return (
    <>
      <Label
        label={cab.label}
        opcionales_null={cab.opcionales_null}
        permite_null={cab.permite_null}
      />
      <Autocomplete
        value={valor}
        id="virtualize-demo"
        sx={{
          width: "100%",
          "& .MuiOutlinedInput-root": {
            height: "50px",
            borderRadius: "5px",
            display: "flex",
            alignItems: "center",
            "& legend": {
              width: "auto !important", // 🔹 Ajusta el tamaño del `legend` para que no oculte el borde
              maxWidth: "0.01px", // 🔹 Truco para evitar que Material UI agrande el `legend`
            },
          },
        }}
        disableListWrap
        disableClearable
        PopperComponent={StyledPopper}
        ListboxComponent={ListboxComponent}
        options={sortedOptions}
        groupBy={(option) => option.label[0].toUpperCase()}
        renderInput={(params) => (
          <TextField
            {...params}
            label={cab.placeholder}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: "50px",
                borderRadius: "5px",
                display: "flex",
                alignItems: "center",
                "& fieldset": {
                  borderWidth: "1px !important",
                  borderColor: "#ccc !important",
                },
                "& legend": {
                  width: "auto !important",
                  maxWidth: "0.01px", // 🔹 Evita que el legend afecte el borde superior
                },
              },
            }}
          />
        )}
        renderOption={(props, option) => [props, option.label]}
        renderGroup={(params) => params}
        onChange={(event, newValue) => handleChangeValue(newValue)}
      />

    </>
  );
}
